import React, {useState} from "react";
import "./ExpenseFilter.css"

const ExpenseFilter = (props)=> {

  

  const selectorHandler = (event)=>{
     props.selectedYear(event.target.value);
    
    
  }

  




    return(
        <div className='expenses-filter'>
        {props.children}
      <div className='expenses-filter__control'>
        <label>Filter by year</label>
        <select onChange={selectorHandler} value={props.yearSelected} >
          <option value='2022'>2022</option>
          <option value='2021'>2021</option>
          <option value='2020'>2020</option>
          <option value='2019'>2019</option>
        </select>
      </div>
    </div>
    )

}

export default ExpenseFilter;